'use client' // Error components must be Client Components

import ErrorContent from '@/components/unable/error-content'
import { logger } from '@/utils/logger'
import { useEffect } from 'react'

export default function ErrorComponent({
  error,
  reset,
}: Readonly<{
  error: Error & { digest?: string }
  reset: () => void
}>) {
  // Log the error to an error reporting service
  useEffect(() => {
    logger.error(
      { message: 'Error boundary caught:' },
      {
        error,
        errorName: error?.name,
        errorMessage: error?.message,
        errorStack: error?.stack,
      }
    )
  }, [error])

  // Handle ChunkLoadError with auto-reload (must be in useEffect for side effects)
  useEffect(() => {
    if (error?.name?.includes('ChunkLoadError')) {
      const loadErrorCount = sessionStorage.getItem('loadErrorCount')
      if (loadErrorCount !== '1') {
        sessionStorage.setItem('loadErrorCount', '1')
        globalThis.location.reload()
      }
    }
  }, [error])

  return (
    <div>
      <ErrorContent
        title="Unable to Proceed"
        description="We are facing some technical issue at the moment."
        callToAction={() => reset()}
      />
    </div>
  )
}
